import React from 'react';
import { FaQuoteLeft } from 'react-icons/fa';

const Testimonial = () => {

    const studentReview = [
        {
            id: 1,
            review: "Great online course! Engaging content, knowledgeable instructors, and convenient learning platform. Highly recommend this educational website.",
            studentImg: "https://i.ibb.co/xS9WJKS/ccfbf25feb.jpg",
            studentName: "Emma Johnson",
        },
        {
            id: 2,
            review: "The online class was informative, interactive, and well-organized. The instructors were excellent, and the platform was user-friendly.",
            studentImg: "https://i.ibb.co/Mn0gQgS/6894d8e1f2.jpg",
            studentName: "Noah Thompson",
        },
        {
            id: 3,
            review: "Impressed with the online course. Easy to navigate, insightful content, and supportive community. Worth enrolling in this educational website.",
            studentImg: "https://i.ibb.co/pr0L1Zh/123c35218d.jpg",
            studentName: "Sophia Anderson",
        },
        {
            id: 4,
            review: "Top-notch online class! Engaging lessons, responsive instructors, and valuable resources. A great learning experience on this educational website.",
            studentImg: "https://i.ibb.co/v3mys8c/6dd69a4f7b.jpg",
            studentName: "Ethan Martinez",
        },
    ]

    return (
        <section className=' my-16'>

            <h2 className='text-[2.5em] text-center mb-16 font-semibold'>Our Successful Student</h2>

            <div className='grid md:grid-cols-2 lg:grid-cols-4 gap-6'>
                {
                    studentReview.map(review => <div
                        key={review.id}
                        className='p-4 border'
                    >
                        <i className='text-2xl text-violet-600 flex justify-center mb-4'><FaQuoteLeft></FaQuoteLeft></i>
                        <p className='text-sm mb-4 text-center'>{review.review}</p>
                        <div className='p-[1px] mb-4 w-8 flex mx-auto bg-violet-300'></div>
                        <div className='flex flex-col items-center'>
                            <img src={review.studentImg} className='w-20 rounded-full' alt="" />
                            <h3 className='text-violet-300 font-semibold'>{review.studentName}</h3>
                        </div>
                    </div>)
                }
            </div>



        </section>
    );
};

export default Testimonial;